import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'isomorphic-fetch';
import './setReactGlobals'; // must run before App so vendor shims see __SAVIYNT_MFE_REACT__ / __SAVIYNT_MFE_REACT_DOM__
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './ECMv6/assets/css/global.css';
import IdentitiesVerification from 'ui-home/src/IdentitiesVerification';
import { injectTokens } from '@saviynt/tokens';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SessionTimeout from 'ui-home/src/logout/SessionTimeout';
import { legacyLibraryRenderPaths } from 'ui-home/src/Constants';
import { App, AppWrapper } from './ui-home/src/App';
import * as serviceWorker from './serviceWorker';
import AppHeader from './ui-home/src/AppHeader';

// eslint-disable-next-line import/prefer-default-export -- needed by webpack
export function initHostApp(hostStore) {
  const isLegacyPath = legacyLibraryRenderPaths.some((path) =>
    window.location.pathname.includes(path),
  );

  // Preserve feature-branch gate: idproofing flow only when `key` is present (narrow mount)
  if (
    window.location.pathname.indexOf('/identities/idproofing/request') > 0 &&
    window.location.search.indexOf('key') > 0
  ) {
    const el = document.getElementById('root');
    if (isLegacyPath) {
      // eslint-disable-next-line react/no-deprecated -- legacyLibraryRenderPaths require ReactDOM.render
      ReactDOM.render(<IdentitiesVerification />, el);
    } else {
      createRoot(el).render(<IdentitiesVerification />);
    }
    return;
  }

  const appComponent = (
    <AppWrapper>
      <BrowserRouter>
        <Switch>
          {/* Public/unauthenticated MFE routes */}
          <Route path="/ECMv6/forms/public/" render={() => <div id="mfe-container" />} />
          <Route path="/ECMv6/identities/idproofing/request" component={IdentitiesVerification} />
          <Route path="/ECMv6/sessiontimeout" component={SessionTimeout} />
          <Route render={() => <App hostStore={hostStore} />} />
        </Switch>
      </BrowserRouter>
    </AppWrapper>
  );

  const rootEl = document.getElementById('root');
  if (isLegacyPath) {
    // eslint-disable-next-line react/no-deprecated -- legacyLibraryRenderPaths require ReactDOM.render
    ReactDOM.render(appComponent, rootEl);
  } else {
    const root = createRoot(rootEl);
    root.render(appComponent);
  }
}

injectTokens();
serviceWorker.unregister();

if (process.env.REACT_APP_MODE === 'ECM') {
  const isLegacyPath = legacyLibraryRenderPaths.some((path) =>
    window.location.pathname.includes(path),
  );
  if (isLegacyPath) {
    // eslint-disable-next-line react/no-deprecated -- legacyLibraryRenderPaths require ReactDOM.render
    ReactDOM.render(<AppHeader />, document.getElementById('header'));
  } else {
    const headerRoot = createRoot(document.getElementById('header'));
    headerRoot.render(<AppHeader />);
  }
}
